import { compareDesc } from 'date-fns'
import { makeAutoObservable } from 'mobx'

import CheckableMap from '@/models/CheckableMap'
import { GroupStudentWorksheet } from './GroupStudentWorksheet'

export class GroupStudentWorksheetColl {
  constructor(
    private groupStudentWorksheetMap: CheckableMap<
      GroupStudentWorksheet['id'],
      GroupStudentWorksheet
    >
  ) {
    makeAutoObservable(this)
  }

  get toArr() {
    return [...this.groupStudentWorksheetMap.values()].sort((a, b) =>
      compareDesc(a.assignDatetime, b.assignDatetime)
    )
  }

  get checkSize() {
    return this.groupStudentWorksheetMap.checkSize
  }

  get toCheckedKeys() {
    return this.groupStudentWorksheetMap.toCheckedKeys
  }

  get toCheckedValues() {
    return this.groupStudentWorksheetMap.toCheckedValues
  }

  get toCheckedStudentWorksheetIds() {
    return this.toCheckedValues.flatMap(({ assignedStudentList }) =>
      assignedStudentList.map(({ studentWorksheetId }) => studentWorksheetId)
    )
  }

  adds(groupStudentWorksheetColl: GroupStudentWorksheetColl) {
    this.groupStudentWorksheetMap.adds(groupStudentWorksheetColl.groupStudentWorksheetMap.entries())
  }

  get(key: number) {
    return this.groupStudentWorksheetMap.get(key)
  }

  set(key: number, value: GroupStudentWorksheet) {
    this.groupStudentWorksheetMap.set(key, value)
  }

  toggleCheck(key: number) {
    this.groupStudentWorksheetMap.toggleCheck(key)
  }

  delete(key: number) {
    this.groupStudentWorksheetMap.delete(key)
  }

  deletes(keys: number[]) {
    this.groupStudentWorksheetMap.deletes(keys)
  }

  isChecked(key: number) {
    return this.groupStudentWorksheetMap.isChecked(key)
  }

  clearAllCheck() {
    this.groupStudentWorksheetMap.clearAllCheck()
  }
}
